import React from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { ReactComponent as TribeLogo } from '../../assets/TribeLogo.svg';
import EventHelpToolTipLeft from '../mixer/Color Mixer UI Components/EventHelpToolTipLeft';

const S = {
  wrapper: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    background: '#fff',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },

  navRow: {
    height: 55,
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
  },

  leftSlot: {
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,
    height: 28,
  },

  exitBtn: {
    padding: '6px 14px',
    borderRadius: 999,
    border: '1px solid #e5e7eb',
    background: '#fff',
    fontWeight: 700,
    fontSize: '0.85rem',
    color: '#0f172a',
    cursor: 'pointer',
  },

  logoCenter: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },

  logo: { width: 72, height: 'auto' },

  /* LIVE pill (replaces occupancy) */
  livePill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '0 12px',
    height: 28,
    borderRadius: 9999,
    backgroundColor: '#E8F5E9',
    color: '#1B5E20',
    fontSize: '0.75rem',
    fontWeight: 800,
    letterSpacing: '.06em',
    textTransform: 'uppercase',
    zIndex: 1,
  },

  liveDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#22C55E',
    animation: 'livePulse 1.6s ease-in-out infinite',
  },
};

export default function NeutralPortalNavBar({
  eventId,
  helpTitle = 'Group Chat',
  helpBody = 'Say hi, coordinate, and enjoy the event.',
    onBack,
}) {
  const location = useLocation();
  const params = useParams();

  const resolvedEventId = String(eventId || params.eventId || '').trim();

  // Detect Neutral portal page
  const isPortalPage = /\/neutral\/[^/]+\/portal/i.test(location.pathname || '');

  function renderLivePill() {
    return (
      <div style={S.livePill} aria-label="Live">
        <span style={S.liveDot} />
        <span>LIVE</span>
      </div>
    );
  }

  return (
    <div style={S.wrapper}>
      <div style={S.navRow}>
        {/* Left: Exit if portal, Tooltip otherwise */}
        <div style={S.leftSlot}>
          {isPortalPage ? (
       <button
  type="button"
  onClick={onBack}
  style={S.exitBtn}
>
  Exit
</button>
          ) : (
            <EventHelpToolTipLeft title={helpTitle} body={helpBody} />
          )}
        </div>

        {/* Center logo */}
        <div style={S.logoCenter}>
          <TribeLogo style={S.logo} />
        </div>

        {/* Right: LIVE */}
        {renderLivePill()}
      </div>

    </div>
  );
}
